import {
  Box,
  Collapse,
  Divider,
  Paper,
  Radio,
  Typography,
} from '@mui/material';
import { ReactNode } from 'react';

type PaymentMethodCardProps = {
  title: string;
  isSelected: boolean;
  onSelect: () => void;
  content: ReactNode;
};

export const PaymentMethodCard = ({
  title,
  isSelected,
  onSelect,
  content,
}: PaymentMethodCardProps) => {
  return (
    <Paper
      elevation={3}
      sx={{
        px: 2.5,
        py: 2,
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
      }}
    >
      <Box
        onClick={onSelect}
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: 1,
          alignItems: 'center',
          cursor: 'pointer',
        }}
      >
        <Radio checked={isSelected} />

        <Typography sx={{ fontWeight: 600 }}>{title}</Typography>
      </Box>

      <Collapse in={isSelected}>
        <Divider sx={{ my: 1 }} />
        {content}
      </Collapse>
    </Paper>
  );
};
